import React from 'react';
import { useRecoilValue } from 'recoil';
import { cdnUrlConfig } from '../../Utils/atoms';

function getDownloadLink() {
	const userAgent = navigator.userAgent.toLowerCase();

	if (userAgent.indexOf('iphone') > -1) {
		return 'https://apps.apple.com/kr/app/%EB%B9%84%EA%B8%80%EC%A6%88-%EA%B0%80%EC%83%81-%ED%8E%AB-%ED%9E%90%EB%A7%81-%EC%95%B1-%EB%B0%98%EB%A0%A4%EB%8F%99%EB%AC%BC-%EC%BA%90%EB%A6%AD%ED%84%B0-%EB%A9%94%ED%83%80%EB%B2%84%EC%8A%A4/id1585622161';
	} else {
		return 'https://play.google.com/store/apps/details?id=com.bigglz.BigglzApp';
	}
}

/**
 * [4월 이벤트] 플레이 소감 작성 이벤트: 프로모션 페이지
 */
const Promotion = () => {
	const isApp = window.location.pathname.includes('mobile'); //URL에 "app"이 포함되면 true
	const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;

	return (
		<div id='wrap'>
			<div className='container'>
				<div className='content Review promotion'>
					{/* 인트로 */}
					<div className='visual'>
						<h1>
							<img
								src={`${IMG_URL}/images/review/img_tit.png`}
								alt='4월 대규모 업데이트 플레이 소감 작성 이벤트'
							/>
						</h1>
						<div className='txt'>
							업데이트된 새 콘텐츠들을
							<span>플레이한 후 소감을 댓글로 작성해주세요!</span>
						</div>
					</div>
					{/* 참여방법 */}
					<div className='event-info howto'>
						<h2>
							<span>참여방법</span>
						</h2>
						<div className='howto-area'>
							<ol>
								<li>
									<div className='tit'>STEP 1</div>
									<div className='txt'>
										4월 업데이트로 새로추가된 콘텐츠 들을 플레이한다.
									</div>
								</li>
								<li>
									<div className='tit'>STEP 2</div>
									<div className='txt'>플레이한 후 소감을 댓글로 등록한다.</div>
								</li>
							</ol>
						</div>
					</div>
					{/* 업데이트 콘텐츠 */}
					<div className='event-info update'>
						<h2>업데이트 콘텐츠</h2>
						<div className='update-area'>
							<ul>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update1.png`}
											alt='펫하우스'
										/>
										<figcaption>펫하우스</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update2.png`}
											alt='청소하기'
										/>
										<figcaption>청소하기</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update3.png`}
											alt='미션 및 업적'
										/>
										<figcaption>미션 및 업적</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update4.png`}
											alt='샤워하기'
										/>
										<figcaption>샤워하기</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update5.png`}
											alt='채집하기'
										/>
										<figcaption>채집하기</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update6.png`}
											alt='무료충전소'
										/>
										<figcaption>무료충전소</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update7.png`}
											alt='랜덤박스'
										/>
										<figcaption>랜덤박스</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update8.png`}
											alt='펫팔파이브'
										/>
										<figcaption>펫팔파이브</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update9.png`}
											alt='마음의소리'
										/>
										<figcaption>마음의소리</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update10.png`}
											alt='핀고정'
										/>
										<figcaption>핀고정</figcaption>
									</figure>
								</li>
							</ul>
						</div>
					</div>
					{/* 이벤트 상세 기간 안내 */}
					<div className='event-info detail'>
						<h2>이벤트 상세 안내</h2>
						<div className='info-area'>
							<ul>
								<li>
									<div className='tit-info'>참여기간</div>
									<div className='txt'>2023년 4월 1일 ~ 4월 30일</div>
								</li>
								<li>
									<div className='tit-info'>발표일</div>
									<div className='txt'>2023년 5월 7일</div>
								</li>
								<li>
									<div className='tit-info'>심사기준</div>
									<div className='txt'>
										플레이 소감을 정성껏 작성해
										<span>주신 분들 중 추첨합니다.</span>
									</div>
								</li>
							</ul>
						</div>
					</div>
					{/* 경품안내 */}
					<div className='event-info product'>
						<h2>
							<span>경품안내</span>
						</h2>
						<ol>
							<li>
								<div className='photo'>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_rewards1.png`}
											alt='GS25 모바일 상품권 10,000원'
										/>
										<figcaption>GS25 모바일 상품권 10,000원 (20명)</figcaption>
									</figure>
								</div>
								<div className='rank top1'>추첨</div>
								<div className='name'>GS25 모바일 상품권 10,000원 (20명)</div>
							</li>
							<li>
								<div className='photo'>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_rewards2.png`}
											alt='젤리 20개'
										/>
										<figcaption>젤리 20개</figcaption>
									</figure>
								</div>
								<div className='rank top2'>2등</div>
								<div className='name'>젤리 20개</div>
							</li>
						</ol>
					</div>
					{/* 주의사항 */}
					<div className='cautionary'>
						<dl>
							<dt>확인해주세요</dt>
							<dd>이벤트 중복 참여 시 1회만 이벤트 참여로 인정됩니다.</dd>
							<dd>
								비글즈 플레이와 관련된 후기만 이벤트 대상이 되며, 관련 없는 글은
								추첨 대상에서 제외될 수 있습니다.{' '}
							</dd>
							<dd>
								이벤트에 당첨되신 분들은 꼭 당첨자 발표 7일 이내로 마이페이지
								&gt; 설정 &gt; 고객센터 1:1 문의 접수 혹은 운영자 이메일 개별
								연락을 통해 휴대전화 번호 혹은 주소를 보내주셔야 합니다.
							</dd>
							<dd>
								기간 내 문의를 접수해 주시지 않을 경우 당첨이 취소될 수
								있습니다.
							</dd>
							<dd>
								이벤트 기간 동안 닉네임 변경 시 당첨정보 확인이 불가하여 당첨이
								취소될 수 있습니다.
							</dd>
							<dd>이벤트 상품은 교환 및 환불이 불가합니다.</dd>
							<dd>기프티콘 선물은 유효 기간 내에 사용해 주셔야 합니다.</dd>
							<dd>
								해당 이벤트는 앱스토어 또는 구글 플레이스토어 등과 무관합니다.
							</dd>
						</dl>
					</div>
					{!isApp && (
						<a
							href={getDownloadLink()}
							target='_blank'
							rel='noopener noreferrer'
							className='btn-download'
						>
							<i></i>앱 다운로드 하러가기
						</a>
					)}
				</div>
			</div>
		</div>
	);
};

export default Promotion;
